import React from 'react';
import { Card, CardBody, CardTitle, Row, Col } from 'reactstrap';
import { PractitionersTableComponent } from '../../../Tables';
import {
  NewPractitionerButton,
  AddPractitionerButton,
} from '../../../../containers/Buttons';
import { ResponsePayload } from '../../../../apis/practitionerRole';
import { IPractitioner } from '../../../../modules/unsw-fhir/Practitioner';
import { Filter } from 'react-table';
import { IPractitionerRole } from '../../../../modules/unsw-fhir/PractitionerRole';

const PractitionerTableCard = (props: {
  practitioners: IPractitioner[];
  organizationId?: string;
  loading?: boolean;
  page?: number;
  pages?: number;
  onFetchData?: (state: any, instance: any) => void;
  filtered?: Filter[];
  practitionerRoles: IPractitionerRole[];
  onPractitionerRolesUpdate: (payload: ResponsePayload) => void;
}) => (
  <Card>
    <CardBody>
      <CardTitle tag="h3">Clinicians</CardTitle>
      <PractitionersTableComponent
        practitioners={props.practitioners}
        loading={props.loading}
        organizationId={props.organizationId}></PractitionersTableComponent>
      <hr />
      <Row>
        <Col>
          <AddPractitionerButton
            practitionerRoles={props.practitionerRoles}
            onPractitionerRolesUpdate={
              props.onPractitionerRolesUpdate
            }></AddPractitionerButton>
        </Col>
        <Col>
          <NewPractitionerButton className="float-right"></NewPractitionerButton>
        </Col>
      </Row>
    </CardBody>
  </Card>
);

export default PractitionerTableCard;
